import React from "react";
import "./Home.css";

export default function Home() {
  return (
    <div className="Home">
      <div className="lander">
        <h1>By Intera</h1>
        <p className="text-muted">Talent Hacking</p>
      </div>
    </div>
  );
}
